import {Box, Divider, Flex, Heading, HStack, Text, useMediaQuery, VStack} from "@chakra-ui/react";
import React, {useEffect, useState} from "react";
import {ConfirmAddress, CopyWallet, TransferConfirm} from "./payment-steps";
import {ReactComponent as RightArrow} from "../../../assets/icons/profile/angle-right_neutral.svg";
import {ReactComponent as QuestionIcon} from "../../../assets/icons/question-circle.svg";
import {ReactComponent as ChatQuestion} from "../../../assets/icons/chat-question.svg";
import {ReactComponent as LightIcon} from "../../../assets/icons/lightbulb.svg";


const stepsInfo = [
    {title: 'Copy the wallet address', description: 'Select crypto, network & copy address.'},
    {title: 'Confirm Address', description: 'Paste address on other exchange.'},
    {title: 'Transfer Confirmation', description: 'Await blockchain confirmation for transfer.'},
]

export const Payment = ({user}) => {
    const [isMobile] = useMediaQuery("(max-width: 778px)")
    const [step, setStep] = useState(1)
    const [completedSteps, setCompletedSteps] = useState([])

    useEffect(() => {
        setCompletedSteps(prevState => [...prevState, step]);
    },[step])

    const addStep = () => {
        setStep(prevState => prevState + 1)
    }

    const cancelSteps = () => {
        setStep(1)
        setCompletedSteps([1])
    }

    const Steps = () => (
        stepsInfo.map((item, index) => (
            <VStack
                key={index}
                w={'full'}
                maxW={'342px'}
                gap={isMobile ? '16px':'24px'}
                align={'start'}
                border={'1px solid'}
                borderRadius={'8px'}
                p={'24px 20px'}
                borderColor={completedSteps.includes(index+1) ? 'purple.500' :'neutral.800'}>
                <HStack
                    gap={'10px'}>
                    <Flex
                        alignItems={'center'}
                        justifyContent={'center'}
                        w={isMobile ? '24px':'32px'}
                        h={isMobile ? '24px':'32px'}
                        fontSize={isMobile ? 'body.xs': 'body.md'}
                        bg={completedSteps.includes(index+1) ? 'purple.500' : 'neutral.800'}
                        borderRadius={'6px'}>
                        {index+1}
                    </Flex>
                    <Heading
                        color={completedSteps.includes(index+1) ? 'purple.500' : 'neutral.100'}
                        fontSize={isMobile ? 'body.md': 'heading.lg'}>
                        {item.title}
                    </Heading>
                </HStack>
                <Text
                    fontSize={'body.xs'}
                    color={'neutral.500'}>
                    {item.description}
                </Text>
            </VStack>
        ))
    )

    return (
        <VStack
            w={'full'}
            maxW={'1124px'}
            gap={'24px'}>
            <Box
                borderRadius={'16px'}
                p={'32px'}
                color={'neutral.100'}
                bg={'neutral.1100'}
                textAlign={isMobile ? 'center': 'start'}
                w={'full'}>
                <Heading fontSize={'heading.3xl'} mb={'32px'}>Deposit Steps</Heading>
                <HStack
                    flexDirection={isMobile ? 'column' : 'row'}
                    w={'full'}
                    gap={'16px'}>
                    <Steps />
                </HStack>
            </Box>
            <Flex
                borderRadius={'16px'}
                w={'full'}
                p={isMobile ? '40px 16px' : '40px'}
                gap={'32px'}
                flexDirection={isMobile ? 'column' : 'row'}
                justifyContent={'space-between'}
                color={'neutral.100'}
                bg={'neutral.1100'}>
                {
                    step === 2 ?
                        <ConfirmAddress
                            isMobile={isMobile}
                            cancelSteps={cancelSteps}
                            addStep={addStep}
                            user={user}/>
                        : step === 3 ?
                            <TransferConfirm
                                isMobile={isMobile}
                                user={user}/>
                                : <CopyWallet
                                    isMobile={isMobile}
                                    addStep={addStep}
                                    user={user}/>
                }
                <VStack
                    mx={'auto'}
                    align={'start'}
                    maxW={'300px'}
                    gap={'24px'}>
                    <HStack>
                        <LightIcon />
                        <Heading fontSize={isMobile ? 'heading.xl' :'heading.2xl'}>Tips</Heading>
                    </HStack>
                    <Divider borderColor={'neutral.800'}/>
                    <Text color={'neutral.500'}>
                        For the safety of your funds, our customer support team may contact you by phone to confirm your
                        withdrawal
                    </Text>
                    <Text color={'neutral.500'}>
                        For the safety of your funds, our customer support team may contact you by phone to confirm your
                        withdrawal
                    </Text>
                    <HStack
                        mt={'36px'}
                        w={'full'}
                        justifyContent={'space-between'}>
                        <HStack>
                            <QuestionIcon />
                            <Text fontSize={'body.lg'}>FAQs</Text>
                        </HStack>
                        <HStack fontSize={'body.xs'} color={'neutral.500'}>
                            <Text>View More</Text>
                            <RightArrow />
                        </HStack>
                    </HStack>
                    <Divider borderColor={'neutral.800'}/>
                    <HStack w={'full'} color={'neutral.500'}>
                        <ChatQuestion />
                        <Text fontSize={'body.lg'}>How to deposit on FalconX?</Text>
                    </HStack>
                    <HStack w={'full'} color={'neutral.500'}>
                        <ChatQuestion />
                        <Text fontSize={'body.lg'}>What is a crypto network?</Text>
                    </HStack>
                    <HStack w={'full'} color={'neutral.500'}>
                        <ChatQuestion />
                        <Text fontSize={'body.lg'}>What network should I use?</Text>
                    </HStack>
                </VStack>
            </Flex>
        </VStack>
    )
}